// src/packages/chubb/travel/chubb_travel_student_2019/TravelStudentCard.jsx
import React from "react";
import "./travel_student.css";

export default function TravelStudentCard({ onSelect }) {
  return (
    <div className="pkg-card chubb-travel-student">
      <div className="pkg-body">
        <h3>Travel Easy — Overseas Student</h3>
        <p>เรียนต่อต่างประเทศ • ค่ารักษา • เคลื่อนย้ายฉุกเฉิน • กระเป๋า/ดีเลย์</p>
        <ul className="pkg-list">
          <li>แผน Student 1–3</li>
          <li>ระยะเวลาคุ้มครอง 3–24 เดือน</li>
          <li>บริการช่วยเหลือฉุกเฉิน 24 ชม. ทั่วโลก</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
